/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as a from "react";
import { uGrid as c, classNames as s } from "@progress/kendo-react-common";
import { DetailCellContainer as m } from "./client/DetailCellContainer.mjs";
const x = (e) => {
  const { colSpan: r, ariaColIndex: d, dataItem: l, dataIndex: i, id: n } = e, t = e.unstyled, o = t && t.uGrid ? t.uGrid : c;
  return /* @__PURE__ */ a.createElement(m, { id: n, dataItem: l }, /* @__PURE__ */ a.createElement(
    "td",
    {
      className: s(o.detailTd({})),
      colSpan: r,
      "aria-colindex": d,
      role: "gridcell"
    },
    /* @__PURE__ */ a.createElement(e.detail, { dataItem: l, dataIndex: i })
  ));
};
export {
  x as GridDetailCell
};
